const path = "insights/insights";

export const FETCH_INSIGHTS_AI_REQUEST = `${path}/FETCH_INSIGHTS_AI_REQUEST`;
export const FETCH_INSIGHTS_AI_SUCCESS = `${path}/FETCH_INSIGHTS_AI_SUCCESS`;
export const FETCH_INSIGHTS_AI_CANCEL = `${path}/FETCH_INSIGHTS_AI_CANCEL`;
export const FETCH_INSIGHTS_AI_ERROR = `${path}/FETCH_INSIGHTS_AI_ERROR`;

export const SHOW_INSIGHTS_AI_SIDEBAR = `${path}/TOGGLE_INSIGHTS_AI_SIDEBAR`;
